<template>
  <transition
    :enter-active-class="transition.enter"
    :leave-active-class="transition.leave">
    <div
      v-show="isActive && message"
      :class="[type, position]"
      class="topbar-onboarding-toast"
      role="alert"
      @click="close">
      <div
        class="topbar-onboarding-toast__icon-wrapper is-align-items-center is-justify-content-center">
        <i
          class="topbar-onboarding-toast__icon is-flex is-align-items-center is-justify-content-center">
          🎉
        </i>
      </div>
      <div class="topbar-onboarding-toast__wrapper">
        <p class="topbar-onboarding-toast__title font-weight-bold">
          Challenge réalisé !
        </p>
        <p class="topbar-onboarding-toast__message">
          {{ message }}
        </p>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'topbar-onboarding-toast',
    props: {
      type: {
        type: String,
        default: 'info',
        validator: value => [
          'info',
        ].indexOf(value) >= 0,
      },
      title: {
        type: String,
        default: '',
      },
      message: {
        type: String,
        default: '',
      },
      icon: {
        type: String,
        default: '',
      },
      queue: {
        type: Boolean,
        default: false,
      },
      duration: {
        type: Number,
        default: 4000,
      },
      position: {
        type: String,
        default: 'bottom',
        validator: value => [
          'top-right',
          'top',
          'top-left',
          'bottom-right',
          'bottom',
          'bottom-left',
        ].indexOf(value) > -1,
      },
    },
    data() {
      return {
        isActive: false,
        parentTop: null,
        parentBottom: null,
        fadeDown: {
          enter: 'fade-in-down',
          leave: 'fade-out-up',
        },
        fadeUp: {
          enter: 'fade-in-up',
          leave: 'fade-out-down',
        },
        defaultIcons: {
          info: 'info',
          success: 'check-circle',
          error: 'x-circle',
          warning: 'alert-circle',
        },
      };
    },
    computed: {
      transition() {
        return this.position.includes('top') ? this.fadeDown : this.fadeUp;
      },
      container() {
        return this.position.includes('top') ? this.parentTop : this.parentBottom;
      },
    },
    beforeMount() {
      this.setupContainer();
    },
    mounted() {
      this.showNotice();
    },
    methods: {
      shouldQueue() {
        if (!this.queue) {
          return false;
        }

        return (this.parentTop.childElementCount > 0 || this.parentBottom.childElementCount > 0);
      },
      close() {
        clearTimeout(this.timer);
        this.isActive = false;

        // Timeout for the animation complete before destroying
        setTimeout(() => {
          this.$destroy();
        }, 150);
      },
      showNotice() {
        if (this.shouldQueue()) {
          setTimeout(() => this.showNotice(), 250);
          return;
        }

        if (this.container.insertAdjacentElement) {
          this.container.insertAdjacentElement('afterbegin', this.$el);
        }

        this.isActive = true;
        this.timer = setTimeout(() => this.close(), this.duration);
      },
      setupContainer() {
        this.parentTop = document.querySelector('.topbar-onboarding-toast-notices.is-top');
        this.parentBottom = document.querySelector('.topbar-onboarding-toast-notices.is-bottom');

        if (this.parentTop && this.parentBottom) {
          return;
        }

        if (!this.parentTop) {
          this.parentTop = document.createElement('div');
          this.parentTop.className = 'topbar-onboarding-toast-notices is-top';
        }

        if (!this.parentBottom) {
          this.parentBottom = document.createElement('div');
          this.parentBottom.className = 'topbar-onboarding-toast-notices is-bottom';
        }

        const container = document.body;

        const style = document.createElement('style');
        style.innerHTML = `
          .topbar-onboarding-toast-notices {
            position: fixed;
            display: flex;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            padding: 2em;
            overflow: hidden;
            z-index: 100000;
            pointer-events: none;

            @media (min-width: 1600px) {
              left: 230px;
            }
          }

          .topbar-onboarding-toast-notices.is-top {
            flex-direction: column;
          }

          .topbar-onboarding-toast-notices.is-bottom {
            flex-direction: column-reverse;
          }
        `;
        document.head.appendChild(style);

        container.appendChild(this.parentTop);
        container.appendChild(this.parentBottom);
      },
      toastIcon(type) {
        return this.icon ? this.icon : this.defaultIcons[type];
      },
    },
  };
</script>

<style lang="scss" scoped>
  $colors: (
    "info": ($color-primary, #F4F9FF),
  );

  .topbar-onboarding-toast {
    position: relative;
    align-items: center;
    animation-duration: 0.15s;
    margin: 0.5em 0;
    border-radius: 42px;
    pointer-events: auto;
    cursor: pointer;
    max-width: 500px;
    background: linear-gradient(180deg, #AF89EF, #7748C8);

    &__icon-wrapper {
      background: #C4A0FF;
      width: 63px;
      height: 63px;
      border-radius: 42px;
    }

    &__icon {
      font-size: 28px;
    }

    &__wrapper {
      flex-direction: column;
      padding: 10px 30px 10px 15px;
    }

    &__title {
      color: $color-white;
      margin-bottom: 5px;
    }

    &__message {
      color: $color-white;
      line-height: 18px;
    }

    &.top, &.bottom {
      align-self: center;
    }

    &.top-right, &.bottom-right {
      align-self: flex-end;
    }

    &.top-left, &.bottom-left {
      align-self: flex-start;
    }
  }
</style>
